import { Children } from 'react';

function SerialComma({ children, conjunction = 'and' }) {
    const items = Children.toArray(children);

    return items.reduce((acc, curr, idx) => {
        if (idx === 0) {
            return curr;
        } else if (idx === items.length - 1) {
            return (
                <>
                    {acc}, {conjunction} {curr}
                </>
            );
        }

        return (
            <>
                {acc}, {curr}
            </>
        );
    }, null);
}

export default SerialComma;
